import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import MainLayout from "../../../layouts/main/main_layout";
import { useFeedback } from "../../../providers/feedback/feeedback";
import {
  deleteAdmins,
  getAdmins,
} from "../../../services/admin/admin_services";
import DeleteUser from "../components/delete_user/delete_uer";
import { AdminListModel } from "../model/admin_list";
import { AdminContext } from "../model/context_provider";
import useUser from "../../../providers/user/user_provider";
import AccessDenied from "../../../components/access_denied/access_denied";
import { useQuery } from "react-query";
import { AdminsList } from "../model/admins_list";
import { queryClient } from "../../../providers/query/query";
import ClientListingPage from "../components/client_listing_page/client_listing_page";
import { deleteClient, getClient, updateClient } from "../../../services/client_mapping/client_mapping";
import { useSelectedOrgStore } from "../../../store/use-selected-org-store";
import { useModuleTabs } from "../hooks/use_module_tabs";

export function useMyContext() {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error("useMyContext must be used within a MyContextProvider");
  }
  return context;
}

export default function ClientMapping() {
  const [deleteAdmin, setDeleteAdmin] = useState(false);
  const [userRoleBreadcrumb, setUserRoleBreadcrumb] =
    useState<string>("dashboard/admin");
  const [selectedAdminRoles, setSelectedAdminRoles] = useState({});
  const [adminList, setAdminList] = useState<AdminListModel[]>([]);
  const [selectedAdminDetails, setSelectedAdminDetails] =
    useState<AdminListModel>({} as AdminListModel);
  const [adminName, setAdminName] = useState("");
  const [adminEmailId, setAdminEmailId] = useState("");
  const [adminRole, setAdminRole] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);

  const [searchList, setSearchList] = useState<AdminListModel[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [page, setPage] = useState(1);

  const { hasPermission } = useUser();
  const { showSnackbar } = useFeedback();
  const { selectedOrgId } = useSelectedOrgStore();
  const { tabs, isLoading: isTabsLoading } = useModuleTabs(selectedOrgId);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchValue]);

  const { data, isLoading: isListLoading, isError } = useQuery(
    ["client-List", currentTab, debouncedSearchValue, page, selectedOrgId, tabs[currentTab]?.key],
    async () => {
      let response = await getClient({
        size: 6,
        page: page,
        module: tabs[currentTab]?.key || 'all',
        keyword: debouncedSearchValue,
        orgId: selectedOrgId
      });
      return response?.data?.data || [];
    },
    { enabled: !isTabsLoading }
  );
  // react-query reports isLoading:false while a query is disabled/idle
  // (waiting on isTabsLoading), so without isTabsLoading here the empty
  // state flashes before the query even starts.
  const isLoading = isTabsLoading || isListLoading;

  const deleteAdminApiCall = () => {
    deleteClient({ clientId: selectedAdminDetails.id })
      .then((res) => {
        setDeleteAdmin(false);
        showSnackbar(res?.data?.data?.message || "");
        queryClient.invalidateQueries({ queryKey: ["client-List"] });
      })
      .catch((e) => {
        setDeleteAdmin(false);
        showSnackbar("Something Went wrong");
      });
  };



  useEffect(() => {
    if (isError) showSnackbar("Something went wrong");
  }, []);

  useEffect(() => {
    setSearchValue('')
    setDebouncedSearchValue('')
  }, [currentTab])

  useEffect(() => {
    setPage(1)
  }, [selectedOrgId])

  return (
    <AdminContext.Provider
      value={{
        userRoleBreadcrumb,
        setUserRoleBreadcrumb,
        setDeleteAdmin,
        deleteAdmin,
        selectedAdminRoles,
        setSelectedAdminRoles,
        adminList,
        setAdminList,
        selectedAdminDetails,
        setSelectedAdminDetails,
        deleteAdminApiCall,
        adminName,
        setAdminName,
        adminRole,
        setAdminRole,
        adminEmailId,
        setAdminEmailId,
        isLoading,
        searchList: data?.list,
        setSearchList,
        searchValue,
        setSearchValue,
      }}
    >
      <MainLayout>
        {/* {hasPermission("Users", "Read") ? ( */}
        <Box>
          <ClientListingPage
            currentTab={currentTab}
            handleChange={(currentTab) => {
              setCurrentTab(currentTab);
              setPage(1)
            }}
            page={page}
            setPage={setPage}
            count={data?.total}
            isError={isError}
            tabs={tabs}
          />
        </Box>
        {/* ) : ( */}
        {/* <Box display="flex" flex={1} width="100%" height="100%">
            <AccessDenied />
          </Box>
        )} */}
        <DeleteUser />
      </MainLayout>
    </AdminContext.Provider>
  );
}
